import React from 'react';
import { IconSvgProps } from '@models/common';

const LabelAIBordered: React.FC<IconSvgProps> = (props) => {
  const { size = 14, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.91667 9.91667V12.25M1.75 11.0833H4.08333M8.16667 1.75L9.5 5.16667L12.8333 6.41667L9.5 7.66667L8.16667 11.0833L6.83333 7.66667L3.5 6.41667L6.83333 5.16667L8.16667 1.75Z'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default LabelAIBordered;
